import React from 'react';
import {DataInfoWindow} from '@/map/components/DataInfoWindow';

interface IProps {
  onClose(): void;
}

const CONTENT = [
  {
    list: [
      {
        title: '배후세대',
        desc: '아파트, 오피스텔(건축법상 업무시설과 주거를 겸한 건물), 빌라(연립주택, 다세대주택), 단독주택(다중주택, 다가구 주택) 세대 수입니다.',
      },
      {
        title: '거주 인구',
        desc: '배후세대 분포와 주민등록인구 수를 바탕으로 추정한 인구수입니다. 실제 거주 형태와 차이가 있을 수 있습니다.',
      },
      {
        title: '직장 인구',
        desc: '전국 사업체 조사 통계를 기반으로 행정동 내 주거 건물을 제외한 건물의 면적과 층수를 고려해 산정한 추정치입니다.',
      },
      {
        title: '유동 인구',
        desc: '이동통신사의 기지국 통신 기반 데이터를 활용한 결과입니다. 도보 이동의 밀도가 가장 높았던 상위 50%의 블록을 표시합니다.',
      },
    ],
  },
  {
    title: '활용 팁',
    list: [
      {
        title: '총 배후세대 수',
        desc: '매장 주변에 거주하는 잠재 고객의 수를 파악할 수 있습니다.',
      },
      {
        title: '주택 유형별 배후세대, 거주 인구, 직장 인구',
        desc: '다양한 주택 유형의 배후세대 수를 비교하여 상권 발달 여부를 파악할 수 있습니다. 거주 인구와 직장 인구를 비교하여 거주 인구가 상대적으로 많은 경우 거주 중심 상권으로 유추할 수 있습니다.',
      },
      {
        title: '유동 인구',
        desc: '분석 지역 내 도보로 이동하는 인구가 밀집된 구간을 확인할 수 있습니다. 주변 프랜차이즈 혹은 주변 정보 마커 기능을 함께 활용하여 지역 내 발달 상권의 위치를 확인할 수 있습니다.',
      },
    ],
  },
];

export const InfoWindow = ({onClose}: IProps) => {
  return (
    <DataInfoWindow
      title="인구 분석 참고"
      content={CONTENT}
      onClose={onClose}
    />
  );
};
